module.exports = __webpack_public_path__ + "img/three.f2348a8a.png";